import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductDetailsFragmentDoc } from './ProductDetails.generated';
export type OrderLineVariantFragment = { variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, properties: Array<{ pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } | null };

export const OrderLineVariantFragmentDoc = gql`
    fragment OrderLineVariantFragment on OrderLineType {
  variant {
    id
    pk
    name
    sku
    weightOverride
    unitCoeff
    properties {
      pk
      attributeName
      valueName
    }
    priceRange {
      currency
      discount {
        min
        max
      }
    }
    ...ProductDetailsFragment
  }
}
    ${ProductDetailsFragmentDoc}`;